export default "__VITE_ASSET__Cwn5pfzU__"